import ActiveRecord, { ActiveRecordSource } from '@mysidewalk/active-record';
/**
 * Represents the request & result of an async calculation specified by
 * "statistic_type".
 *
 * @property {string} characteristic_collection
 * @property {string} statistic_type
 * @property {string} column_id
 * @property {number} layer_id
 * @property {string} record_id
 * @property {*} result
 * @property {string} status
 * @property {string?} error
 */
class StatisticsRequest extends ActiveRecord {
    /**
     * @type {boolean}
     */
    get isComplete() {
        return this.status === 'complete';
    }
}
StatisticsRequest.$AR = {
    url: '',
    SourceClass: ActiveRecordSource,
    options: {
        responseRecordsPropertyName: null,
        responseMetadataPropertyName: null,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    },
};
export default StatisticsRequest;
